/* assets/market-spelling.js
   Replaces NZ/UK spellings with US spellings for US visitors.
   Only changes visible TEXT NODES (won't touch URLs, class names, data attrs).

   Improvements:
   - Faster on large pages (quickTest skip)
   - Optional "do not touch" wrapper class: .no-spelling-swap
*/
(function () {
  if (!window.__SPELLING_IS_US__) return;

  // Add/remove terms here (NZ/UK -> US)
  // NOTE: Order matters a bit: keep longer phrases ABOVE shorter ones.
  const pairs = [
    // ===== Wine terminology / US wording =====
    ["dealcoholised", "dealcoholized"],
    ["Dealcoholised", "Dealcoholized"],
    ["DEALCOHOLISED", "DEALCOHOLIZED"],

    // 27 Oct 2026 (David): "non-alcoholic", "alcohol-removed" and similar are NEVER
    // swapped to "dealcoholized". US copy uses non-alcoholic / alcohol-free / NA wine
    // as people search; "dealcoholized" lives on the front label only.
    // This script is being retired: US text gets fixed at source in the templates.

    // ===== General NZ/UK -> US spelling =====
    ["flavour", "flavor"],
    ["flavours", "flavors"],
    ["colour", "color"],
    ["colours", "colors"],
    ["favourite", "favorite"],
    ["favourites", "favorites"],
    ["centre", "center"],
    ["centres", "centers"],
    ["organise", "organize"],
    ["organised", "organized"],
    ["organising", "organizing"],
    ["organisation", "organization"],
    ["programme", "program"],
    ["grey", "gray"],

    // Optional: wine/legal (only keep if you want)
    ["sulphur", "sulfur"],
    ["sulphite", "sulfite"],
    ["sulphites", "sulfites"],
  ];

  // Quick pre-check to skip most nodes fast (edit if you add new root words)
  const quickTest = /(flavou|colou|favour|centre|organis|programm|grey|sulph|dealcohol)/i;

  // Build regexes once, with word boundaries, case-insensitive
  const rules = pairs.map(([from, to]) => ({
    to,
    re: new RegExp("\\b" + escapeRegExp(from) + "\\b", "gi"),
  }));

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function preserveCaseReplace(match, replacement) {
    // UPPERCASE: FLAVOUR -> FLAVOR
    if (match.toUpperCase() === match) return replacement.toUpperCase();
    // Title Case: Flavour -> Flavor
    if (match[0] && match[0].toUpperCase() === match[0]) {
      return replacement.charAt(0).toUpperCase() + replacement.slice(1);
    }
    // lowercase: flavour -> flavor
    return replacement;
  }

  function convertText(text) {
    let out = text;
    for (const r of rules) {
      out = out.replace(r.re, (m) => preserveCaseReplace(m, r.to));
    }
    return out;
  }

  function shouldSkipNode(node) {
    if (!node || !node.parentNode) return true;
    const p = node.parentNode;
    if (p.nodeType !== 1) return false;

    // Manual opt-out anywhere in theme:
    // Wrap areas you don't want touched with <div class="no-spelling-swap">...</div>
    if (p.closest && p.closest(".no-spelling-swap")) return true;

    const tag = p.tagName;
    // skip scripts/styles + inputs + anything editable
    if (
      tag === "SCRIPT" ||
      tag === "STYLE" ||
      tag === "NOSCRIPT" ||
      tag === "TEXTAREA" ||
      tag === "INPUT"
    ) return true;

    if (p.isContentEditable) return true;
    return false;
  }

  function walkAndReplace(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (shouldSkipNode(node)) return NodeFilter.FILTER_REJECT;
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;

          // Speed: skip nodes that clearly can't match our word list
          if (!quickTest.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;

          return NodeFilter.FILTER_ACCEPT;
        },
      },
      false
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (const n of nodes) {
      const original = n.nodeValue;
      const updated = convertText(original);
      if (updated !== original) n.nodeValue = updated;
    }
  }

  // Initial pass
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => walkAndReplace(document.body));
  } else {
    walkAndReplace(document.body);
  }

  // Keep it working for dynamic content (cart drawers, quick add, etc.)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1) walkAndReplace(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();